import React, { useEffect } from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/tech-preferences.png";
import { IntegrationPrefereImg, TechSignupImg } from "../../components/Icons/iconImages";
import { Button } from "antd";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import ReactGA from "react-ga4";


const IntegrationPreference = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const defaultValues = {
        excisitingTool: [],
        ecommerce_platform: []
    };
    const {
        getValues,
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues,
    });

    useEffect(() => {
        let integration = state?.integration;
        if (integration) {
            let excisitingTool = integration?.excisitingTool || [];
            let ecommerce_platform = integration?.ecommerce_platform || [];
            setValue('excisitingTool', excisitingTool);
            setValue('ecommerce_platform', ecommerce_platform);
        }
    }, [state])
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const handleSignUp = async () => {

        ReactGA.event('tech_integration_preferences_done', {
            method: 'manual_selection',
            user_type: 'new_user',
        });

        navigate('/select-goals', {
            state: {
                ...state,
                integration: getValues()
            }
        });
    }
    const handleSubmitError = (data: any) => {
        // console.log('error triggered', data)
    }

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">One Screen for GA4, Google Ads, Meta, Shopify & CRM</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">Create a free account and get full access to all features for 30-days.
                {' '}  <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    No credit card needed.
                </span>{' '}
            </p>}
            // background={BackgroundImg}
            icon={<IntegrationPrefereImg className="h-[80px] w-[80px] " />}
            percent={70}
            currentStep={4}
            routeState={
                {
                    ...state,
                    integration: getValues()
                }
            }
        >
            <div className="h-[calc(100vh-21rem)] max-w-[480px] mx-auto w-full">
                <div className=" text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <TechSignupImg className="w-[28px] h-auto" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">Tech & Integration Preferences</p>
                    <p className="text-[#535862] text-md mt-2">A few details to set things up for you and your team</p>
                </div>
                <form onSubmit={handleSubmit(handleSignUp, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
                    <div className="max-w-[416px] w-full rounded-2xl flex flex-col space-y-4 md:space-y-4 h-full">
                        <div className="p-4 border border-[#E9EAEB] rounded-xl w-full">
                            <p className="text-[#414651] font-semibold  text-base md:text-lg mb-4">Existing Analytics & Ad Tools</p>
                            <Controller
                                control={control}
                                name="excisitingTool"
                                render={({ field: { onChange, value = [] } }: any) => {
                                    const toggleValue = (val: string) => {
                                        if (value.includes(val)) {
                                            onChange(value.filter((v: string) => v !== val));
                                        } else {
                                            onChange([...value, val]);
                                        }
                                    };

                                    return (
                                        <div className="flex flex-wrap items-center gap-2">
                                            {[
                                                { label: 'GA4', value: 'GA4' },
                                                { label: 'Google Ads', value: 'Google_Ads' },
                                                // { label: 'CRM', value: 'CRM' },
                                                { label: 'Meta', value: 'Meta' },
                                                { label: 'Other', value: 'Other' },
                                            ].map((tab, index) => (
                                                <span
                                                    key={index}
                                                    className={`cursor-pointer text-xs w-fit font-normal inline-flex items-center px-4 py-2 rounded-full 
              ${value.includes(tab.value)
                                                            ? "border border-[#B6F0D5] text-[#FFFFFF] bg-[#609F81] font-semibold"
                                                            : "border border-gray-400 text-[#414651] font-semibold bg-gray-100"
                                                        }`}
                                                    onClick={() => toggleValue(tab.value)}
                                                >
                                                    {tab.label}
                                                </span>
                                            ))}
                                        </div>
                                    );
                                }}
                            />


                        </div>

                        <div className="p-4 border border-[#E9EAEB] rounded-xl">
                            <p className="text-[#414651] font-semibold  text-base md:text-lg mb-4">E-Commerce Platform</p>
                            <Controller
                                control={control}
                                name="ecommerce_platform"
                                render={({ field: { onChange, value } }: any) => {
                                    const toggleValue = (val: string) => {
                                        if (value.includes(val)) {
                                            onChange(value.filter((v: string) => v !== val));
                                        } else {
                                            onChange([...value, val]);
                                        }
                                    };

                                    return (
                                        <div className="flex flex-wrap items-center gap-2">
                                            {[
                                                { label: 'Shopify', value: 'Shopify' },
                                                { label: 'WooCommerce', value: 'WooCommerce' },
                                                { label: 'Magento', value: 'Magento' },
                                                { label: 'Other', value: 'Other' },
                                            ].map((tab, index) => (
                                                <span
                                                    key={index}
                                                    className={`cursor-pointer text-xs w-fit font-normal inline-flex items-center px-4 py-2 rounded-full ${value.includes(tab.value)
                                                            ? "border border-[#B6F0D5] text-[#FFFFFF] bg-[#609F81] font-semibold"
                                                            : "border border-gray-400 text-[#414651] font-semibold bg-gray-100"
                                                        }`}
                                                    onClick={() => toggleValue(tab.value)}
                                                >
                                                    {tab.label}
                                                </span>
                                            ))}
                                        </div>
                                    );
                                }}
                            />

                        </div>


                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError(null)} />
                            </div>
                        )}

                    </div>
                    <div className="flex items-center gap-6 w-full max-w-[416px]">
                        <p className="text-[#609F81] cursor-pointer font-semibold" onClick={() => navigate('/about-your-company', {
                            state: {
                                ...state,
                            }
                        })}>Back</p>

                        <Button
                            type='primary'
                            className="w-full"
                            disabled={loading}
                            loading={loading}
                            // onClick={() => handleSignUp()}
                            htmlType="submit"

                        >
                            Continue
                        </Button>
                    </div>
                </form>
            </div>
        </SignupLayout>
    )
};

export default IntegrationPreference;
